var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4E6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5232_181404",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 9.33334C12.3202 9.33334 9.3335 12.32 9.3335 16C9.3335 19.68 12.3202 22.6667 16.0002 22.6667C19.6802 22.6667 22.6668 19.68 22.6668 16C22.6668 12.32 19.6802 9.33334 16.0002 9.33334ZM16.0002 21.3333C13.0535 21.3333 10.6668 18.9467 10.6668 16C10.6668 13.0533 13.0535 10.6667 16.0002 10.6667C18.9468 10.6667 21.3335 13.0533 21.3335 16C21.3335 18.9467 18.9468 21.3333 16.0002 21.3333ZM19.3335 16C19.3335 17.841 17.8411 19.3333 16.0002 19.3333C14.1592 19.3333 12.6668 17.841 12.6668 16C12.6668 14.1591 14.1592 12.6667 16.0002 12.6667C17.8411 12.6667 19.3335 14.1591 19.3335 16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5232_181404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#2B323B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButton);
export default __webpack_public_path__ + "static/media/radioButton.af458c27921190f35f04bc2bbb60afd5.svg";
export { ForwardRef as ReactComponent };